module.exports = __webpack_public_path__ + "static/media/599.7554(18).4b7c4f92.pdf";